export enum TournamentWinnersType {
    FIXED = 'fixed',
    PERCENTS = 'percents',
}